import { fetchWithAuth, getCSRFToken } from '../../auth';

const API_HOST = process.env.REACT_APP_ICC_TOOL_API_HOST;

function questionsUrl (suffix = '') {
    return `${API_HOST}questions/${suffix}`;
}

const readOpts = () => ({
    headers: { 'X-CSRFToken': getCSRFToken() },
    credentials: 'include',
});

const writeOpts = (method, body) => {
    const opts = {
        method,
        headers: { 'X-CSRFToken': getCSRFToken() },
        credentials: 'include',
    };
    if (body !== undefined) {
        opts.headers['Content-Type'] = 'application/json';
        opts.body = JSON.stringify(body);
    }
    return opts;
};

async function throwIfNotOk (resp, fallback) {
    if (resp.ok) {
        return;
    }
    const err = await resp.json().catch(() => ({}));
    if (typeof err.detail === 'string' && err.detail) {
        throw new Error(err.detail);
    }
    const firstKey = Object.keys(err).find((key) => Array.isArray(err[key]) && err[key].length);
    if (firstKey) {
        throw new Error(err[firstKey][0]);
    }
    throw new Error(fallback);
}

export async function fetchQuestions () {
    const resp = await fetchWithAuth(questionsUrl(), readOpts());
    await throwIfNotOk(resp, 'Failed to fetch questions.');
    return resp.json();
}

export async function fetchQuestion (id) {
    const resp = await fetchWithAuth(questionsUrl(`${id}/`), readOpts());
    await throwIfNotOk(resp, 'Failed to fetch question.');
    return resp.json();
}

export async function createQuestion (payload) {
    const resp = await fetchWithAuth(questionsUrl(), writeOpts('POST', payload));
    await throwIfNotOk(resp, 'Failed to submit question.');
    return resp.json();
}

export async function updateQuestion (id, payload) {
    const resp = await fetchWithAuth(questionsUrl(`${id}/`), writeOpts('PATCH', payload));
    await throwIfNotOk(resp, 'Failed to update question.');
    return resp.json();
}

export async function deleteQuestion (id) {
    const resp = await fetchWithAuth(questionsUrl(`${id}/`), writeOpts('DELETE'));
    await throwIfNotOk(resp, 'Failed to delete question.');
    if (resp.status === 204) {
        return null;
    }
    return resp.json().catch(() => null);
}

export async function answerQuestion (id, answer) {
    const resp = await fetchWithAuth(
        questionsUrl(`${id}/answer/`),
        writeOpts('POST', { answer }),
    );
    await throwIfNotOk(resp, 'Failed to answer question.');
    return resp.json();
}

export async function fetchAnswerers () {
    const resp = await fetchWithAuth(questionsUrl('answerers/'), readOpts());
    await throwIfNotOk(resp, 'Failed to fetch answerers.');
    return resp.json();
}
